// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client'; // createRoot(container!) if you use TypeScript

// project imports
import App from 'App';
import * as serviceWorker from 'serviceWorker';
import reportWebVitals from 'reportWebVitals';

// style + assets
import 'assets/scss/style.scss';
import AppWrapper from './utils/AppWrapper';

const container = document.getElementById('root');
const root = createRoot(container!);

// ==============================|| REACT DOM RENDER  ||============================== //

root.render(
    <AppWrapper>
        <App />
    </AppWrapper>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
